module.exports = __webpack_public_path__ + "static/media/MHeiHK-Medium.6f17765e.svg";